<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      lock-scroll
      top="5vh"
      :append-to-body="true"
      custom-class="material-selection-dialog"
      width="1200px"
    >
      <!-- 分组 -->
      <select-material-content
        ref="selectMaterialContent"
        :limit="limit"
        :is-multi="isMulti"
        :show-sort="showSort"
        :material-type="materialType"
      ></select-material-content>
      <!-- 列表 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">
          {{ $t('shopDecoration.home.controls.cancel') }}
        </el-button>
        <el-button type="primary" @click="confirm">
          {{ $t('common.confirm') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SelectMaterialContent from './components/select-material-content.vue';
import editDialog from '@/mixins/edit-dialog';
import SearchTableMixin from '@/mixins/search-table';

export default {
  components: { SelectMaterialContent },
  mixins: [editDialog, SearchTableMixin(false)],
  props: {
    materialType: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      default: 1,
    },
    // 为了区别返回值是否是数组, 兼容之前的用法
    isMulti: {
      type: Boolean,
      default: false,
    },
    showSort: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CONST,
    };
  },
  watch: {
    dialogVisible(v) {
      if (!v) {
        this.claer();
      } else {
        this.initData();
      }
    },
  },

  methods: {
    claer() {
      this.$refs.selectMaterialContent.clear();
    },
    initData() {
      // 首次打开由组件内部刷新
      this.$refs.selectMaterialContent &&
        this.$refs.selectMaterialContent.initData();
    },
    confirm() {
      const curSelectList = this.$refs.selectMaterialContent.curSelectList;
      if (_.isEmpty(curSelectList)) {
        this.$message.info('请先选择一项');
        return;
      }
      this.close();
      this.$emit('selected', this.isMulti ? curSelectList : curSelectList[0]);
    },
  },
};
</script>
<style lang="scss">
.material-selection-dialog {
  > .el-dialog__header {
    display: none;
  }
  > .el-dialog__body {
    padding: 0;
  }
}
</style>
